<div class="container p-0">
  <div class="row align-items-end">
    <div class="col">
      @if (!message.Payload.IsMultiline) {
        <input [placeholder]="message.Payload.Placeholder||''" [type]="inputType" class="form-control form-control-text me-sm-3 mb-0" [(ngModel)]="textInput" autocorrect="off" (scOnEnter)="send()">
      }
      @if (message.Payload.IsMultiline) {
        <textarea #multilineInput rows="1" [placeholder]="message.Payload.Placeholder||''" class="form-control form-control-text me-sm-3 mb-0" [(ngModel)]="textInput" (ngModelChange)="resizeTextArea()" autocorrect="off"></textarea>
      }
      @if (error) {
        <p class="small text-danger">{{ error }}</p>
      }
    </div>
    <div class="col-auto pl-0">
      <button class="btn btn-dark btn-circle send-button" [disabled]="!textInput" (click)="send()">
        <i class="fa-sharp fa-solid fa-paper-plane-top"></i>
      </button>
    </div>
  </div>
</div>